import { render, staticRenderFns } from "./Leroy.vue?vue&type=template&id=53335192&"
import script from "./Leroy.vue?vue&type=script&lang=js&"
export * from "./Leroy.vue?vue&type=script&lang=js&"
import style0 from "./Leroy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports